import Icon from '../components/Icon.vue'

Icon.register({
  'star-of-david': {
    width: 464,
    height: 512,
    paths: [
      {
        d: 'M405.7 256l53.2 89.4c14.4 24.2-3.4 54.6-32 54.6h-106.9l-56 94c-7.1 12-19.6 18-32 18s-24.9-6-32-18l-56-94h-106.9c-28.6 0-46.4-30.4-32-54.6l53.2-89.4-53.2-89.4c-14.4-24.2 3.4-54.6 32-54.6h106.9l56-94c7.1-12 19.6-18 32-18s24.9 6 32 18l56 94h106.9c28.6 0 46.4 30.4 32 54.6zM392.9 168h-39.6l19.8 33.3zM340.5 256l-52.4-88h-112.3l-52.4 88 52.4 88h112.2zM232 73.7l-22.8 38.3h45.6zM71.1 168l19.8 33.3 19.8-33.3h-39.6zM71.1 344h39.6l-19.8-33.3zM232 438.3l22.8-38.3h-45.6zM353.3 344h39.6l-19.8-33.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/star-of-david.js
// module id = null
// module chunks = 